import Vue from 'vue';
import store from '@/store';
import ApiEndpoints from '@/config/ApiEndpoints';
import ApiService from '@/services/ApiService';
import CountryService from '@/services/logistics/CountryService';
import { getVariant, getDeliveryPrice } from '@/helpers/QueryHelpers';

export default class RegisterCustomer {
    apiService;

    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);
    }

    // Handle registering a new WEB customer.
    handle(tokenId, cardId, paymentMethod, nameOfCard) {
        const payload = { ...this.getPayload(),
            stripe_token: tokenId,
            stripe_card_id: cardId,
            payment_method: paymentMethod,
            name_on_card: nameOfCard };

        return this.apiService
            .post(ApiEndpoints['users.register.store'], payload);
    }

    getPayload() {
        let payload = {};
        const uuid = store.getters['register/getIncompleteRegistrantUuid'];
        const deliveryAddress = store.getters['register/getDeliveryAddress'];
        const deliveryAddressIsBilling = store.getters['register/getDeliveryAddressIsBilling'];
        let billingAddress = store.getters['register/getBillingAddress'];
        const productId = store.getters['register/getSelectedProductID'];
        const selectedProduct = store.getters['register/getSelectedProductDetails'];
        billingAddress = deliveryAddressIsBilling ? deliveryAddress : billingAddress;

        if (uuid) {
            payload.incomplete_registration_uuid = uuid;
        }

        if (productId) payload.primary_product_id = productId;
        if (selectedProduct?.product_family) payload.product_family = selectedProduct?.product_family;

        // const billingIso = billingAddress.country instanceof Object ? billingAddress.country.iso : billingAddress.country;
        let billingIso = process.env.VUE_APP_COUNTRY_ISO;
        const billingAddressCountry = CountryService.findCountryByIso(billingIso).name;
        const deliveryAddressCountry = CountryService.findCountryByIso(deliveryAddress.country).name;
        const optInMarketing = store.getters['register/getOptInMarketing'];
        const originURL = process.env.VUE_APP_ORIGIN_URL || '';
        const selectedPlan = store.getters['register/getSelectedPlan'];

        let queryParams = '';
        if (!/(%3C*|<)[^*]?script/gi.test(Vue.prototype.$globalQueryParams.queryString)) {
            queryParams = Vue.prototype.$globalQueryParams.queryString;
        }

        return {
            ...payload,
            billing_address_first_name: store.getters['register/getFirstName'],
            billing_address_last_name: store.getters['register/getLastName'],
            billing_address_line_1: billingAddress.addressLine1,
            billing_address_line_2: billingAddress.addressLine2,
            billing_address_city: billingAddress.city,
            billing_address_postcode: billingAddress.postcode,
            billing_address_country: billingAddressCountry,
            coupon_code: store.getters['register/getFriendCode'],
            delivery_address_line_1: deliveryAddress.addressLine1,
            delivery_address_line_2: deliveryAddress.addressLine2,
            delivery_address_city: deliveryAddress.city,
            delivery_address_postcode: deliveryAddress.postcode,
            delivery_address_country: deliveryAddressCountry,
            delivery_address_property_type: store.getters['register/getPropertyType'],
            delivery_instructions: store.getters['register/getDeliveryComment'],
            delivery_amount: getDeliveryPrice(),
            email: store.getters['register/getEmail'],
            first_name: store.getters['register/getFirstName'],
            last_name: store.getters['register/getLastName'],
            opt_in_marketing: optInMarketing,
            opt_in_third_party_marketing: store.getters['register/getOptInThirdPartyMarketing'],
            originURL: originURL,
            password: store.getters['register/getPassword'],
            telephone: store.getters['register/getTelephone'],
            awc: this.getAwinCookie(),
            preferred_delivery_day: this.getPreferredDeliveryDay(),
            plan_slug: selectedPlan.plan_interval,
            mode: getVariant(),
            free_first_delivery: false,
            source_id: store.getters['register/getSourceId'],
            region_id: store.getters['register/getRegionId'],
            canvasser_id: store.getters['register/getCanvasserId'],
            paramsPayload: {
                queryParams,
            },
        };
    }

    getAwinCookie() {
        const awinKey = `_aw_m_${process.env.VUE_APP_AWIN_KEY}`;
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${awinKey}=`);

        return parts.length === 2 ? parts.pop().split(';').shift() : null;
    }

    getPreferredDeliveryDay() {
        const selectedDay = store.getters['register/getPreferredDeliveryDay'];
        const defaultDay = store.getters['register/getFirstDeliveryDay'];
        return selectedDay === defaultDay ? null : selectedDay;
    }
}
